// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {MDBBtn, MDBCol, MDBRow} from 'mdbreact';
import DatePicker from 'react-datepicker';

import CustomTimePicker from '../../../layout/CustomTimePicker';
import Notification from '../../../notification';

import combineDateAndTime from '../../../../utils/addTimeToDatefromAM_PMFormatString';
import formatAMPM from '../../../../utils/formatAMPM';
import getLocalTime from '../../../../utils/formatToWOTimezone';

class AddCheckInCheckOut extends React.Component {
    constructor(props) {
        super(props);

        const timezone = props.currentWorkOrder.coords?.timeZone;
        this.state = {
            startTime: formatAMPM(getLocalTime(timezone?.timeZoneId)),
            date: new Date(),
            time: formatAMPM(getLocalTime(timezone?.timeZoneId)),
            description: '',
        };
    }

    componentDidUpdate(prevProps) {
        // eslint-disable-next-line react/destructuring-assignment
        if (!prevProps.showCheckField && this.props.showCheckField) {
            // eslint-disable-next-line react/no-did-update-set-state
            const timezone = this.props.currentWorkOrder.coords?.timeZone;
            this.setState({
                startTime: formatAMPM(getLocalTime(timezone?.timeZoneId)),
                date: new Date(),
                time: formatAMPM(getLocalTime(timezone?.timeZoneId)),
                description: '',
            });
        }
    }

    handlerSubmitButton = async (event) => {
        event.preventDefault();
        const {date, time, description} = this.state;
        const {showCheckIn, currentWorkOrder, checkInCheckOutToWorkOrder} = this.props;
        if (!date || !time || (!description.trim() && !showCheckIn)) {
            Notification('warning', {message: 'Please Enter Description of Work Performed!'});
            return;
        }
        const sendData = {
            date: await combineDateAndTime(date, time),
        };
        if (!showCheckIn) {
            if (
                new Date(sendData.date) < new Date(currentWorkOrder?.checkInOutDetails[0]?.check_in_date)
            ) {
                // eslint-disable-next-line consistent-return
                return Notification('warning', {message: 'Check-out time must be later than check-in time'});
            }
            sendData.description = description || '';
        }
        const result = await checkInCheckOutToWorkOrder(
            currentWorkOrder._id,
            !showCheckIn && currentWorkOrder.checkInOutDetails[0]?._id,
            sendData,
        );
        if (result) {
            this.setState((prevState) => ({
                ...prevState,
                date: '',
                time: '',
                description: '',
            }));
        }
    }

    handlerChange = (date, name) => {
        this.setState({
            [name]: date,
        });
    };

    render() {
        const {showCheckIn, currentWorkOrder, showCheckField} = this.props;
        const {
            date, description, time, startTime,
        } = this.state;
        return (
            <form onSubmit={this.handlerSubmitButton}>
                {showCheckField && (
                    <div>
                        <div>
                            <div>
                                <div className="field_row">
                                    <div className="field_name">
                                        <label>
                                            {`Check ${showCheckIn ? 'In' : 'Out'} Date`}
                                        </label>
                                    </div>
                                    <div className="field_block">
                                        <DatePicker
                                            className="form-control coutd"
                                            dateFormat="MM/dd/yy"
                                            name="date"
                                            selected={date}
                                            value={date}
                                            onChange={(value) => {
                                                this.handlerChange(value, 'date');
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="field_row">
                                    <div className="field_name">
                                        <label className="font11">
                                            {`Check ${showCheckIn ? 'In' : 'Out'} Time`}
                                        </label>
                                    </div>
                                    {console.log({startTime})}
                                    <div className="field_block">
                                        <CustomTimePicker
                                            className="cint"
                                            id="timePicker"
                                            hours={startTime.slice(0, startTime.indexOf(':'))}
                                            minutes={startTime.slice(startTime.indexOf(':') + 1, -2)}
                                            dayTime={startTime.slice(-2)}
                                            name="time"
                                            hoursFormat={12}
                                            getValue={(value) => {
                                                this.handlerChange(value, 'time');
                                            }}
                                            value={time}
                                        />
                                    </div>
                                </div>
                            </div>
                                <div className="field_row">
                                    {!showCheckIn && (
                                        <div className="field_row">
                                        <div className="field_name">
                                            <label className="font11">Description of Work Performed</label>
                                        </div>
                                            <div className="field_block">
                                            <textarea
                                                type="text"
                                                className="form-control descheck font11"
                                                placeholder="Description/Remark"
                                                name="description"
                                                value={description}
                                                onChange={({target}) => {
                                                    this.handlerChange(target.value, 'description');
                                                }}
                                            />
                                            </div>
                                        </div>
                                    )}
                                </div>
                        </div>
                        <div className="dashboard-modal-footer">
                            <button
                                type="submit"
                                color="info"
                                className="dashboard-btn dashboard-btn--primary"
                                disabled={currentWorkOrder.onHold}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                )}
            </form>
        );
    }
}

export default AddCheckInCheckOut;
